import React from "react";

function BS4_Dropdowns() {
  return (
    <div>
      <h1>BS4_Dropdowns Component</h1>
      <p>This is the BS4_Dropdowns tutorial page content.</p>
    </div>
  );
}

export default BS4_Dropdowns;
